<div class="d-flex">
  <div class="left-panel bg-white p-3">
    <div class="logo row">
      <div class="col-12">
        <img src="../../../../assets/images/company_logo.png" alt="" />
      </div>
    </div>
    <div class="wrapper row">
      <div class="col-12">
        <form id="formContent" name="authForm">
          <h1 class="box-title">
            <strong>{{ errDetails.title }}</strong>
          </h1>

          <div class="error-text">
            <div>
              <span>&#9888;</span> {{ errDetails.description }}
              <!-- <div class="error-reason" *ngIf="reason">{{ reason }}</div> -->
              <div class="wcf-button login-btn" *ngIf="errDetails.reloginButton">
                <button (click)="redirectToLogin()" type="button" class="log-btn styled">
                  <span>Retry Sign in?</span>
                </button>
              </div>
              <div class="wcf-button login-btn" *ngIf="errDetails.homepageButton">
                <button (click)="redirectToLogin()" type="button" class="log-btn styled">
                  <span>Return</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="right-panel">
    <div class="bg-img">
      <div class="inner-box">
        <div class="bottom-zero">
          <p>EAF <sup>&copy;</sup></p>
          <p>Enterprise Automation Fabric<sup class="sub-title">&copy;</sup></p>
        </div>
      </div>
    </div>
  </div>
</div>
